<script>
import ProInput from '$common/ProInput'
export default {
  name: 'StudentNote',
  components: {
    'pro-input': ProInput,
  },
  props: {
    options: {
      required: true,
    }
  },
  data () {
    return {
      note: ''
    }
  },
  methods: {
    async onSubmit(){
      const noteUpdate = this.$firestore.collection('users').doc(this.options.student.id).update({notes: this.note})

      try {
        await Promise.all([noteUpdate])
      } catch (e) {
        console.error(e)
        this.$toast('Note did not save. Please try again.')
        return
      }

      this.$toast('Note saved.')
      this.$modals.hide('student-note')

      const successFunc = this.options.onSuccess
      if (successFunc) successFunc()
    }
  },
  mounted () {
    this.note = this.options.student.notes
  },
}
</script>

<template lang="pug">
  #note-main.modal-main
    .note-container.modal-container
      .title Notes
      .content
        .notes-section
          .pro-form
            .form-row
              pro-input(
                v-model='note'
                :options='{type: "textarea"}'
              )
      .action
        .button.minor(
          @click='$modals.hide(`student-note`)'
        ) Cancel
        span
        .button.major(
          @click='onSubmit'
        ) Save
</template>

<style lang="sass" scoped>

</style>